<template>
  <div class="animated fadeIn">
    <basic-heading title="Lab Instruments" class="mb-3">
      <template #right-content>
        <header-button-group :button_config="button_config" />
      </template>
    </basic-heading>
    <permission-alert-gate :permissions="'list instrument instance'">
      <template #gated-content>
        <instrument-instance-server-table />
      </template>
    </permission-alert-gate>
  </div>
</template>

<script>
import BasicHeading from "@/components/shared/BasicHeading";
import HeaderButtonGroup from "@/components/shared/headerbuttons/HeaderButtonGroup";
import InstrumentInstanceServerTable from "@/components/lab/instrumentinstance/InstrumentInstanceServerTable";
import PermissionAlertGate from "@/components/permission/PermissionAlertGate";
import { AccessControlCheck } from "@/auth/AccessControlCheck"

export default {
  name: "InstrumentInstanceIndex",
  components: {
    BasicHeading,
    HeaderButtonGroup,
    InstrumentInstanceServerTable,
    PermissionAlertGate
  },
  computed: {
    button_config() {
      return {
        buttons: [
          {
            icon: "fa-plus",
            linkto: "/instrument-instances/add",
            title: "Add instrument instance",
            variant: "success",
            permission: this.checkPermission("add instrument instance")
          }
        ]
      };
    }
  },
  methods: {
    checkPermission(permission) {
      return AccessControlCheck.checkPermission(permission);
    }
  }
};
</script>
